// extracted by mini-css-extract-plugin
export default {"statusCell":"StatusCell_statusCell__QKsDH","statusBadge":"StatusCell_statusBadge__DKDID"};